import React, { Fragment, useContext, lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import ProtectedRoute from '../routing/ProtectedRoute';
import ProtectedLogin from '../routing/ProtectedLogin';
import ContextApi from '../ContextApi';
import LoadingSpinner from '../container/layout/LoadingSpinner';

const Home = lazy(() => import('../pages/Home'));
const Releases = lazy(() => import('../pages/Releases'));
const News = lazy(() => import('../pages/News'));
const CategoryArticles = lazy(() => import('../component/CategoryArticles'));
const NewsArticle = lazy(() => import('../component/NewsArticle'));
const Contact = lazy(() => import('../pages/Contact'));
const AuthPage = lazy(() => import('../pages/AuthPage'));
const ScreeningRoom = lazy(() => import('../pages/ScreeningRoom'));
const MovieProfile = lazy(() => import('../pages/MovieProfile'));
const About = lazy(() => import('../pages/About'));
const MovieScreen = lazy(() => import('../pages/MovieScreen'));
const NoMatch = lazy(() => import('../pages/NoMatch'));


const ContentRouter = () => {
    const { auth } = useContext(ContextApi)

    return (
        <Fragment>
                <Suspense fallback={<LoadingSpinner />} >
                    <Switch>
                        <Route exact path="/" component={Home} />
                        <Route path="/releases/:genre" component={Releases} />
                        <Route exact path='/news' component={News} />
                        <Route path='/news/category/:genre?' component={CategoryArticles} />
                        <Route path='/news/:date?/:header?' component={NewsArticle} />
                        <Route path="/contact" component={Contact} />
                        <ProtectedLogin path='/login' auth={auth} component={AuthPage} />
                        <ProtectedRoute path='/screening-room' auth={auth} component={ScreeningRoom} />
                        <Route path='/about' component={About} />
                        <Route exact path="/movie-profile/:id/:movieTitle" component={MovieProfile} />
                        <ProtectedRoute path='/movie-screen/:id?' auth={auth} component={MovieScreen} />
                        <Route exact path="/series-profile/:seriesTitle/:mediaCode" component={MovieProfile} />
                        <Route component={NoMatch} />
                    </Switch>
                </Suspense>
        </Fragment>
    )
};

export default ContentRouter; 